import styled from 'styled-components';

export const BundleOfferSideBarStyled = styled.div`
.imageicon{
    position: absolute;
    left: 303px;
    top: -56px;
}
.title{
display: flex;
flex-direction: column;
}
.ima{
    display: flex;
}
`;
